function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPreRead = function SvgPreRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 56840",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29764",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26114",
    d: "M32 84.75v-35A1.75 1.75 0 0 1 33.75 48h38.5A1.75 1.75 0 0 1 74 49.75v35l-7-3.5-7 3.5-7-3.5-7 3.5-7-3.5z",
    transform: "translate(-25 -37.5)",
    style: {
      stroke: "#3f54d9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1048",
    transform: "translate(23.5 18.5)",
    style: {
      stroke: "#3f54d9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    },
    d: "M0 0h18.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1049",
    transform: "translate(14.585 25.5)",
    style: {
      stroke: "#3f54d9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    },
    d: "M0 0h27.415"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1050",
    transform: "translate(14.585 32.5)",
    style: {
      stroke: "#3f54d9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    },
    d: "M0 0h27.415"
  }));
};

export default SvgPreRead;